import { EVisitType, OrderDetail, OrderDetailActiveAppointments } from '@giffgaff/broadband-common'

import dayjs from 'dayjs'

import { formatDate } from '@/utils/formatDate/formatDate'

import { appointmentUpdate } from '../ChangeInstallDates.container'
import { EOrderStage, stagesInOrder } from './propTypeHelpers'

// make it less coupled the API implementation
// make it only think about one appointment
export function appointmentCanBeAmended(activeAppointments: OrderDetail['appointments'] | undefined) {
  if (!activeAppointments) {
    return {
      preWork: false,
      inHome: false,
    }
  }

  const preWorkAppointment = activeAppointments.find(appt => appt.visitType === EVisitType.PRE_WORK)
  const inHomeAppointment = activeAppointments.find(appt => appt.visitType === EVisitType.IN_HOME)

  const preWorkAmendable = preWorkAppointment?.amendable ?? false
  const inHomeAmendable = inHomeAppointment?.amendable ?? false

  return {
    preWork: preWorkAmendable,
    inHome: inHomeAmendable,
  }
}

export function formatDateForDisplay(date: string) {
  if (!date || date === 'Invalid Date') return ''

  return formatDate(date, { year: 'short' })
}

export function formatDateTime(formattedDate: string, formattedTime: string) {
  return `${formattedDate} ${formattedTime}`.trim()
}

export function compareDateAndSlot(originalAppt?: OrderDetailActiveAppointments, updatedAppt?: appointmentUpdate) {
  if (!updatedAppt) return false

  return updatedAppt.date !== originalAppt?.appointmentDate || originalAppt?.slot !== updatedAppt.slot?.slot
}

export function getAppointmentDateFormatted(date: string | undefined, time: string | undefined) {
  const formattedDate = formatDateForDisplay(date || '')
  const formattedTime = time || ''

  return formatDateTime(formattedDate, formattedTime)
}

export const todayOrLeadDate = (proposedDate: dayjs.Dayjs): dayjs.Dayjs => {
  const today = dayjs()

  return proposedDate.isBefore(today) ? today : proposedDate
}

export function appointmentNeedsRebookingButUnchanged({
  originalAppt,
  submittedDate,
  submittedSlot,
}: {
  originalAppt: OrderDetailActiveAppointments | undefined
  submittedDate: string
  submittedSlot: string
}): boolean {
  if (!originalAppt?.rebookingRequired) return false

  return submittedDate === originalAppt.appointmentDate && submittedSlot === originalAppt.slot
}

export const appointmentIsComplete = (
  orderStage: EOrderStage,
  visitType: EVisitType.IN_HOME | EVisitType.PRE_WORK,
): boolean => {
  const visitTypeIndex = visitType === EVisitType.PRE_WORK ? 1 : 2
  const orderStageIndex = stagesInOrder.indexOf(orderStage)

  return orderStageIndex > visitTypeIndex
}
